import axios from 'axios';
import { msgAlert } from '.';

const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  responseType: 'json'
})

export default API;

// *********************************  Add a request interceptor  *******************************
API.interceptors.request.use(config => {

  const isaddDietplan = config?.url?.includes('add?dietPlanId=');
  if(isaddDietplan) {
    config.headers['platform'] = 'android';
    config.headers['campaignId'] = '--';
  }
  // spinning start to show
  // UPDATE: Add this code to show global loading indicator
  document.body.classList.add('loading-indicator');
  const token = localStorage.getItem('token');
  const country = localStorage.getItem('country');
  
  if(token)
      config.headers['Authorization'] = 'Bearer ' + token;
  if(country)
      config.baseURL = country === 'ae' ? process.env.REACT_APP_BASE_URL_UAE : process.env.REACT_APP_BASE_URL
  
  return config;

},error => {
  // Do something with request error
  return Promise.reject(error);
});

// *******************************   Add a response interceptor   ********************************
API.interceptors.response.use(response => {
    
  // spinning hide
  // UPDATE: Add this code to hide global loading indicator
  document.body.classList.remove('loading-indicator');

  // Any status code that lie within the range of 2xx cause this function to trigger
  return response;

},(error) => {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // const originalRequest = error.config;
  if(error.response && error.response.status && error.response.config && !error.response.config.url.includes('activation-code/verify')) {
      const erorrData = error?.response?.data;
      switch (error.response.status) {
          case 400 :
            if(erorrData?.message)
             // msgAlert(erorrData?.error, erorrData.message, true, true);
            console.log("ERROR - erorrData.message");
            else
              console.log("ERROR - 400");
          break;
          case 401 :
            msgAlert('Error...', '401 - Unauthorized', false, false);
          break;
          case 403 :
            console.log("ERROR - 403");
          break;
          case 404 :
            if(erorrData) 
              msgAlert(erorrData?.error, erorrData.message, true, true);
            else
              msgAlert('Error...', '401 - Unauthorized', false, false);
          break;
          case 500 :
            console.log("ERROR - 500");
          break;
          default:
              console.log('API - Switch default', error.response);
      }
      // spinning hide
      // UPDATE: Add this code to hide global loading indicator
      document.body.classList.remove('loading-indicator');

  } else {
      console.error("Network Error");
  }
  

  return Promise.reject(error);
});